import React, { Component } from 'react';
import { connect } from 'react-redux';

// import Tabs from '../../components/Tab';
// import SearchUser from './SearchUser';
// import AllUsers from './AllUsers';
import MoveToKit from '../MoveToKit';
// import UserProfile from '../UserProfile';
import { Wrapper } from './style';
import { getTabParams } from '../../common/utils';

class Users extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            tabParams: getTabParams()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.props.location) !== JSON.stringify(prevProps.location)) {
            this.setState({ tabParams: getTabParams() });
        }
    }

    render() {
        // const { tabParams } = this.state;
        // const UsersTabList = [
        //     {
        //         key: 'search',
        //         name: 'Search',
        //         path: '/search',
        //         content: <MoveToKit />
        //     },
        //     {
        //         key: 'all users',
        //         name: 'All Users',
        //         path: '/all-users',
        //         content: <MoveToKit />
        //     }
        // ];
        return (
            <Wrapper>
                <div className="main-header">
                    Users
				</div>
                {/* {tabParams.id
                    ? <UserProfile
                        exchange={this.props.exchange}
                        tabParams={tabParams}
                        history={this.props.history}
                    />
                    : <Tabs TabList={UsersTabList} activeTab={tabParams.tab} />
                } */}
                {/* <Tabs TabList={UsersTabList} activeTab={tabParams.tab} /> */}
                <MoveToKit />
            </Wrapper>
        )
    }

}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {}
});

export default connect(mapStateToProps)(Users);
